import { Users } from '@platform/client';
import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'wouter';
import PageFooter from './layout/PageFooter';
import PageHeader from './layout/PageHeader';
import PageSubHeader from './layout/PageSubHeader';

const App = ({ children }: { children: React.ReactElement }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef<HTMLDivElement>(null);

  const userData = Users.useGetCurrentUser();
  const isAuthed = userData.isSuccess;
  const isLoading = userData.isLoading;
  const [location, navigate] = useLocation();

  useEffect(() => {
    if (!isAuthed && !isLoading) {
      navigate(`/auth/login?next=${location}`, { replace: true });
    }
  }, [isAuthed, navigate, location, isLoading]);

  useEffect(() => {
    const hideSidebar = (e: MouseEvent) => {
      if (isSidebarOpen && !e.composedPath().includes(sidebarRef.current as HTMLDivElement)) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener('click', hideSidebar, true);
    return () => document.removeEventListener('click', hideSidebar, true);
  }, [isSidebarOpen]);

  return (
    <div>
      <Helmet>
        {/** This is just a default and will be overwritten by a similar <Helmet> tag in each specific page */}
        <title>MovingWorlds</title>
      </Helmet>
      <PageHeader
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        sidebarRef={sidebarRef}
      />
      <div className='hidden md:block'>
        <PageSubHeader />
      </div>
      <div className='overflow-y-scroll h-[calc(100vh-54px)] md:h-[calc(100vh-140px)]'>
        {children}
        <PageFooter />
      </div>
    </div>
  );
};

export const UnauthedApp = ({ children }: { children: React.ReactElement }) => {
  return (
    <div className={'h-[100vh]'}>
      <Helmet>
        {/** This is just a default and will be overwritten by a similar <Helmet> tag in each specific page */}
        <title>MovingWorlds</title>
      </Helmet>
      {children}
    </div>
  );
};

export default App;
